export const directionColour = {
  NORTH: '#ef4444',
  EAST: '#3b82f6',
  SOUTH: '#22c55e',
  WEST: '#f97316',
};

const sum = (values) => values.reduce((total, value) => total + value, 0);

/**
 * Totals the seven on-screen figures over the roof faces the API returned. The
 * API owns every per-face value; Chameleon only sums. Rounds once, after summing.
 */
export const computeTotals = (
  sides = [],
  { kwPerPanel = 0, sunHoursDivisor = 0, sunHoursCap = Infinity } = {}
) => {
  // Today every returned side is counted and drawn. Letting the user deselect a
  // roof face they don't own (honouring side.isDisplayed) is future front-end
  // work, so isDisplayed is intentionally not read yet.
  const shown = sides ?? [];

  const maxPanels = sum(shown.map((side) => side.panels ?? 0));
  const yearlyOutput = Math.round(
    sum(shown.map((side) => side.energy?.amount ?? 0))
  );
  const systemCapacity = maxPanels * kwPerPanel;

  const sunHoursDivisorTotal = maxPanels * kwPerPanel * sunHoursDivisor;
  const avgSunHours =
    sunHoursDivisorTotal > 0
      ? Math.min(Math.round(yearlyOutput / sunHoursDivisorTotal), sunHoursCap)
      : 0;

  return {
    suitableFaces: shown.length,
    maxPanels,
    usableRoofArea: Math.round(
      sum(shown.map((side) => side.area?.usable ?? 0))
    ),
    yearlyOutput,
    systemCapacity,
    avgSunHours,
    annualSavings: Math.round(
      sum(shown.map((side) => side.annualSavings?.amount ?? 0))
    ),
    currencyCode: shown[0]?.annualSavings?.currencyCode,
  };
};
